import React from 'react';
import styles from './Loader.module.scss';

const Loader = ({ loading = false, style, color, ...rest }) => {
  const spinnerStyle = color ? { borderTopColor: color } : {};

  return (
    <div style={{ ...style, textAlign: 'center', padding: '2rem' }} {...rest}>
      {loading && (
        <div className={styles.loader__spinner} style={spinnerStyle} />
      )}
    </div>
  );
};

export default Loader;
